import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { State } from './fixedPages.reducer';
import { storeFixedPagesKey } from '@streamamg/components-lib';

export const FixedPagesState = (state: AppState) => state[storeFixedPagesKey];

export const selectFixedPages = createSelector(
  FixedPagesState,
  (state: State) => state.fixedPages,
);
